import React from "react";
import { useQuery } from "@apollo/client";
import { CollapsibleApplicantProfile } from "../../../../../shared/collapsible-applicant-profile/collapsible-applicant-profile";
import { ApplicantUserProfessional, ApplicantUserContactInformation, ApplicantUserIdentityDetails, ApplicantUserCitizenship, Entity, CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryDocument } from "../../../../../../generated";
import { lookupCountryQuery } from './send-report-archive-country-query'
import { Country } from "../../../../../../types/country";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";


interface CollapsibleApplicantProfileContainerProps {
  caseId: string;
}

export const CollapsibleApplicantProfileContainer: React.FC<
  CollapsibleApplicantProfileContainerProps
> = (props) => {
  const {
    data: countryData,
    loading: countryLoading,
    error: countryError,
  } = useQuery(lookupCountryQuery);

  const {
    data: applicantDetailData,
    loading: applicantDetailLoading,
    error: applicantDetailError,
  } = useQuery(
    CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryDocument,
    {
      variables: {
        archivedSendReportCaseSummaryId: props.caseId,
      },
      context: {
        headers: {
          "cache-enabled": "true",
        },
      },
    }
  );
  

  return (
    <ComponentQueryLoader
      loading={applicantDetailLoading || countryLoading}
      hasData={applicantDetailData?.archivedSendReportCaseSummary?.applicant}
      error={applicantDetailError || countryError}
      hasDataComponent={
        <CollapsibleApplicantProfile
          professional={applicantDetailData?.archivedSendReportCaseSummary?.applicant?.personalInformation?.professional as ApplicantUserProfessional}
          contactInformation={applicantDetailData?.archivedSendReportCaseSummary?.applicant?.personalInformation?.contactInformation as ApplicantUserContactInformation}
          identityDetails={applicantDetailData?.archivedSendReportCaseSummary?.applicant?.personalInformation?.identityDetails as ApplicantUserIdentityDetails}
          citizenship={applicantDetailData?.archivedSendReportCaseSummary?.applicant?.personalInformation?.citizenship as ApplicantUserCitizenship} 
          applyingTo={applicantDetailData?.archivedSendReportCaseSummary?.applicant?.personalInformation?.applyingTo as Entity[]}  
          countryData={
            countryData?.countries?.eventPayload?.countries as Country[]
          }
        />
      }
    />
  );
};
